import script from "./DetalleActividad.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleActividad.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleActividad.vue?vue&type=style&index=0&id=9da29822&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9da29822"]])

export default __exports__